import React, { useEffect, useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Grid, Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Item } from '../../../common/snippets'
import { cargoUnloadingStylesWithFormattedLR, cargoUnloadingTblDefs, cargoUnloadingTblStyles, headerTblDefs } from './constants'
import { cellStyles, headCellStyles, totalRowStyles } from './constants';
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { callAddFontRobotoBold } from '../../../common/font/font/Roboto-bold';
import { callAddFontRobotoMedium } from '../../../common/font/font/Roboto-Medium-normal';
import * as sx from '../../../common/stylesInline/report_daily_branch'
const CargoUnloadingReportTable = (props) => {
  const { dataValues } = props
  const { roleRights, loginData, filters, cargoUnloadingTableData, columns, allownFormatLR } = dataValues
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const [tableData, setTableData] = useState([])
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  useEffect(() => {
    let newData = []
    if (cargoUnloadingTableData?.length >= 1) {
      newData = cargoUnloadingTableData
      let totalRow = calculateTotal(newData)
      setTableData([...newData, totalRow])
    } else {
      setTableData([])
    }
  }, [cargoUnloadingTableData])
  const hraderTableData = [
    { fromDate: moment(filters?.fromDate).format('DD-MMM-YY'), branchName: filters?.branchName?.BranchName, vehicleNo: filters?.vehicleNo?.VehicleNo }
  ]
  const calculateTotal = (arr) => {
    let row = {
      isTotalRow: true, LRNO: 'TOTAL', NOP: 0, CHARGEDWEIGHT: 0, FREIGHT: 0, NETAMOUNT: 0
    }
    for (let i = 0; i < arr.length; i++) {
      row.NOP += Number(arr[i].NOP)
      row.CHARGEDWEIGHT += Number(arr[i].CHARGEDWEIGHT)
      row.FREIGHT += Number(arr[i].FREIGHT)
      row.NETAMOUNT += Number(arr[i].NETAMOUNT)
    }
    return row
  }
  const SecontInsideRowContent = (props) => {
    const { item, index, fontVal } = props
    return (
      item.isTotalRow ?
        <><TableRow >
          <TableCell colSpan={allownFormatLR===3?6:5} style={{ ...totalRowStyles, fontSize: fontVal, textAlign: 'right', borderBottomLeftRadius: '8px' }}>{item.LRNO}</TableCell>
          <TableCell colSpan={1} style={{ ...totalRowStyles, fontSize: fontVal }}>{item.NOP}</TableCell>
          <TableCell colSpan={1} style={{ ...totalRowStyles, fontSize: fontVal }}>{item.CHARGEDWEIGHT}</TableCell>
          <TableCell colSpan={1} style={{ ...totalRowStyles, fontSize: fontVal }}>{item.FREIGHT}</TableCell>
          <TableCell colSpan={1} style={{ ...totalRowStyles, fontSize: fontVal }}>{item.NETAMOUNT}</TableCell>
          <TableCell colSpan={1} style={{ ...totalRowStyles, fontSize: fontVal }}>{""}</TableCell>
        </TableRow>
        </>
        :
        <>
          <TableRow key={`party-booking-${index}`}>
           {(allownFormatLR===0||allownFormatLR===1||allownFormatLR===3) && <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.LRNO}</TableCell>}
           {(allownFormatLR===2||allownFormatLR===3) && <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.FormattedLRNO}</TableCell>}
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.FromCity}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.ToCity}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.Sender}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.Receiver}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'right' }}>{item.NOP}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'right' }}>{item.CHARGEDWEIGHT}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'right' }}>{item.FREIGHT}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'right' }}>{item.NETAMOUNT}</TableCell>
            <TableCell style={{ ...cellStyles, fontSize: fontVal, textAlign: 'left' }}>{item.status}</TableCell>
          </TableRow>
        </>
    )
  }

  const generatepdf = (isSave) => {
  try {
    setIsPdfLoaded(false);
    setState({ ...state, load: true, generatePDF: true });
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold]);
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium]);
    const doc = new jsPDF({
      orientation: 'p',
      format: [1240, 1754],
      unit: 'px',
      compress: true
    });
    doc.setProperties({
      title: `CargoUnloadingReport.pdf`,
      subject: 'Cargo Unloading',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Cargo Unloading Report',
      creator: 'MTLPL'
    });
    const totalPagesExp = '{total_pages_count_string}';
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc;
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ?? pageSize.getHeight();
      const pageWidth = pageSize.width ?? pageSize.getWidth();
      let str = 'Page : ' + doc.internal.getNumberOfPages();
      if (typeof doc.putTotalPages === 'function') {
        str += ' of ' + totalPagesExp;
      }
      doc.setFontSize(16);
      doc.text(str, pageWidth - data.settings.margin.left, pageHeight - 5, 'right');
      doc.setFont('Roboto', 'bold');
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5);
      const reportTime = `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`;
      doc.text(
        reportTime,
        pageWidth / 2 - (doc.getStringUnitWidth(reportTime) * doc.internal.getFontSize()) / 2 + 90,
        pageHeight - 5
      );
    };
    const styleTotalRow = (row, allownFormatLR) => {
      const firstCell = row.cells[0];
      if (firstCell) {
        firstCell.colSpan = allownFormatLR === 3 ? 6 : 5;
        Object.assign(firstCell.styles, {
          font: 'Roboto',
          halign: 'right',
          fontStyle: 'bold',
          fontSize: 16,
          fillColor: [238, 238, 238]
        });
      }
      for (let i = 5; i <= 10; i++) {
        if (row.cells[i]) {
          Object.assign(row.cells[i].styles, {
            font: 'Roboto',
            fontStyle: 'bold',
            fontSize: 16,
            fillColor: [238, 238, 238]
          });
        }
      }
    };
    autoTable(doc, {
      margin: { left: 30, right: 30, bottom: 5 },
      startY: 124,
      alternateRowStyles: { fillColor: [255, 255, 255] },
      theme: 'grid',
      columns: headerTblDefs,
      body: hraderTableData,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 16,
        lineWidth: 0.6,
        font: 'Roboto',
        fontStyle: 'normal'
      },
      columnStyles: {
        0: { cellWidth: 390, fontSize: 16, valign: 'middle', font: 'Roboto', halign: 'left' },
        1: { cellWidth: 390, fontSize: 16, valign: 'middle', font: 'Roboto', halign: 'left' },
        2: { cellWidth: 390, fontSize: 16, valign: 'middle', font: 'Roboto', halign: 'left' }
      },
      didParseCell: (data) => {
        if (data.row.index === 0) data.cell.styles.textColor = '#000000';
      },
      didDrawPage: (data) => jsPdfHeaderFooter(data, loginData, totalPagesExp)
    });
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 60 },
      startY: doc.lastAutoTable.finalY + 24,
      alternateRowStyles: { fillColor: [255, 255, 255] },
      theme: 'grid',
      columns: columns,
      showHead: 'everyPage',
      body: tableData,
      tableLineWidth: 0.6,
      rowPageBreak: 'avoid',
      styles: { lineWidth: [0, 0.6, 0, 0.6] },
      columnStyles: allownFormatLR === 3
        ? cargoUnloadingStylesWithFormattedLR
        : cargoUnloadingTblStyles,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 12,
        valign: 'top',
        font: 'Roboto',
        fontStyle: 'normal'
      },
      didParseCell: (data) => {
        const rows = data.table.body;
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].includes(data.column.raw.xlCol.dataType)) {
            data.cell.styles.halign = 'right';
          } else {
            data.cell.styles.halign = 'left';
          }
        }
        rows.forEach((val) => {
          if (val.raw && val.raw.isTotalRow) styleTotalRow(val, allownFormatLR);
        });
      },
      didDrawPage: (data) => {
        doc.setTextColor(40);
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50);
        doc.setFontSize(26).setFont('Roboto', 'bold');
        doc.setTextColor(16, 79, 162);
        doc.text('Cargo System | Cargo Unloading Report', 90, 80);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(22).setFont('Roboto', 'normal');
        doc.text(
          `Company Name : ${loginData.strCompanyName}`,
          doc.internal.pageSize.width - data.settings.margin.left,
          80,
          'right'
        );
        jsPdfHeaderFooter(data, loginData, totalPagesExp);
      }
    });
    doc.setFont('Roboto');
    if (typeof doc.putTotalPages === 'function') doc.putTotalPages(totalPagesExp);
    setIsPdfLoaded(true);
    setTimeout(() => {
      const pdfUrl = doc.output('bloburl')
      document.getElementById('CargoUnloadingReportID').data = pdfUrl
      // const pdfURI = doc.output('datauristring', 'CargoUnloadingReport.pdf');
      // document.getElementById('CargoUnloadingReportID').data = pdfURI;
      focusElemnt('cuBackBtn');
      if (isSave) doc.save(`Cargo Unloading Report ${currentDateTime}.pdf`);
       setState((prev) => ({ ...prev, generatePDF: false, load: true }));
    }, 1000);
  } catch (err) {
    console.error('PDF Generation Error:', err);
    setIsPdfLoaded(false);
  }
};

  return (
    <>
      <Grid container className="bookingItemButtons" sx={{ padding: '0px 5px 0px 0px' }}>
        <Box
          style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '13px' }}
        >
          <h2 style={{ paddingLeft: '15px' }}>Report For: Cargo Unloading Report</h2>
        </Box>
        {!isPdfLoaded ? (
          <Box style={{ display: 'flex', justifyContent: 'flex-end', width: '50%', alignItems: 'center' }}>
            <Box>
              <Item>
                {roleRights?.Table1[0]?.AllowExportExcel === 1 ?
                  <div onKeyDown={(e) => { navigation3(e, 'exportAsPdfBtn', 'cu-SplitButton', () => { }) }}>
                    <ReactHtmlTableToExcel
                      id="cu-test-table-xls-button"
                      className="BookingItemExcelBtn"
                      table="table-to-xls"
                      filename={`Cargo Unloading Report ${currentDateTime}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </div> :
                  <Button variant="outlined" sx={{ width: '100%' }} className="BookingItembtn" disabled={true}>
                    Export to Excel
                  </Button>}
              </Item>
            </Box>
            <Box>
              <Item>
                <Button
                  variant="outlined"
                  className="BookingItembtn"
                  onClick={() => { generatepdf(true) }}
                  // onKeyDown={(e) =>navigation3(e, 'PrintBtn', disableExcel ? 'franchiseeSplitBtn' : 'ExpToExlbtn', () => {generatepdf(true)})}
                  id="exportAsPdfBtn"
                >
                  Export to Pdf
                </Button>
              </Item>
            </Box>
            <Box>
              <Item>
                <Button
                  variant="outlined"
                  className="BookingItembtn"
                  onClick={() => { generatepdf(false) }}
                  id="PrintBtn"
                // onKeyDown={(e) =>navigation3(e, 'fromDate', 'exportAsPdfBtn', () => {generatepdf(false)})}
                >
                  Print
                </Button>
              </Item>
            </Box>
          </Box>
        ) : (
          <>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', width: '50%', alignItems: 'center', paddingRight: '10px' }}>
              <Button
                id='cuBackBtn'
                style={{
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  fontSize: '15px',
                  color: '#fe5200',
                  background: 'white',
                  marginLeft: '620px',
                  border: '2px solid #fe5200',
                }}
                onClick={() => setIsPdfLoaded(false)}
              >
                Back
              </Button>
            </Box>
          </>
        )}
      </Grid>
      {!isPdfLoaded ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 1.5, height: 430, paddingTop: '10px' }} >
            <TableContainer className="scroll" style={{ border: '1px solid #aeaeae', borderRadius: '6px' }} component={Paper}>
              <Table className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    {columns.map((col, index) => (
                      <TableCell
                        align={col.align}
                        sx={{ ...headCellStyles, ...col.headerSx }}
                        key={`th-${col.field}-${index}`}
                      >
                        {col.header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={17}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <SecontInsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table style={{ display: 'none' }} id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={Math.floor(columns.length / 2)}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Cargo Unloading Report </h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={columns.length - Math.floor(columns.length / 2)}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={columns.length}></TableCell>
                  </TableRow>

                  <TableRow >
                    <TableCell
                      className="ReportItemHead"
                      style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                      colSpan={3}
                    >
                      Dispatch Date
                    </TableCell>
                    <TableCell className="ReportItemHead"
                      style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                      colSpan={3}
                    >
                      Branch Name
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                      colSpan={4}
                    >
                      Vehicle No.
                    </TableCell>
                  </TableRow>
                  <TableRow >
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        ...cellStyles, fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                      }}
                      colSpan={3}
                    >{moment(filters?.fromDate)?.format('DD-MMM-YY')}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        ...cellStyles, fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                      }}
                      colSpan={3}
                    >
                      {filters?.branchName?.BranchName}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        ...cellStyles, fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                      }}
                      colSpan={4}
                    >
                      {filters?.vehicleNo?.VehicleNo}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={columns?.length}></TableCell>
                  </TableRow>
                  <TableRow>
                    {(allownFormatLR==0||allownFormatLR===1||allownFormatLR===3) && <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>LR No.</TableCell>}
                    {(allownFormatLR===2||allownFormatLR===3) &&<TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>Formatted LR No.</TableCell>}
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>From City</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>To City</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>Sender Name</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>Receiver Name</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'right', color: '#444444' }}>NOP</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'right', color: '#444444' }}>Charged Weight</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'right', color: '#444444' }}>Freight Charge</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'right', color: '#444444' }}>Total Amount</TableCell>
                    <TableCell style={{ ...headCellStyles, fontSize: '16px', width: "150px", textAlign: 'left', color: '#444444' }}>LR Status</TableCell>
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={17}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '20px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '20px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <SecontInsideRowContent item={item} index={index} key={index} fontVal={'14px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
          <>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                <object
                  id="CargoUnloadingReportID"
                  type="application/pdf"
                  width="100%"
                  height="440"
                  title="MTLPL - Cargo Unloading Report"
                  aria-label="MTLPL - Cargo Unloading Report"
                ></object>
              </Box>
            ) : (
              ''
            )}
          </>
      )}
    </>
  )
}

export default CargoUnloadingReportTable
